(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("jotApp")

.constant("ENV", "prod")

.constant("VERSION", "1.39.0")

.constant("STOMP_DEBUG", false)

;
})();
